import {
  Button,
  Icon,
  Inline,
  NavButton,
  Separator,
} from "@generalapplications/ui";
import { useLocation } from "react-router-dom";

import { isCallToAction, primaryNavigation } from "@/content/navigation";

import {
  isActive,
  sectionPages,
} from "@/app/common/functions/routes/sectionNavigation";
import { SectionMenu } from "./SectionMenu";

/**
 * The desktop bar: the sections as plain text, the current one tinted, those
 * with pages opening a panel (the marks and colours live in there); then a
 * short rule and the one call to action, Contact, an outline button in the
 * section tone, which this site's theme maps to its signal colour.
 */
export function DesktopNavigation() {
  const { pathname } = useLocation();
  const sections = primaryNavigation.filter((item) => !item.emphasized);
  const contact = primaryNavigation.find(isCallToAction);
  return (
    <Inline as="nav" aria-label="Primary navigation" gap="xs">
      {sections.map((item) => {
        const active = isActive(item.href, pathname);
        const pages = sectionPages[item.href];
        if (pages)
          return (
            <SectionMenu
              key={item.href}
              label={item.label}
              href={item.href}
              pages={pages}
              active={active}
              align={item.href === "/industries" ? "end" : "start"}
            />
          );
        return (
          <NavButton
            key={item.href}
            href={item.href}
            active={active}
            aria-current={active ? "page" : undefined}
          >
            {item.label}
          </NavButton>
        );
      })}
      {contact && (
        <>
          <Separator orientation="vertical" short />
          <Button
            href={contact.href}
            variant="outline"
            tone="section"
            size="lg"
            aria-current={isActive(contact.href, pathname) ? "page" : undefined}
          >
            <Icon icon={contact.icon} placement="start" />
            {contact.label}
          </Button>
        </>
      )}
    </Inline>
  );
}
